module.exports = __webpack_public_path__ + "static/media/acura-header-logo.579c6601.svg";